// 是否是测试
let isTest = true
isTest = false

let baseURL = ''
if (isTest) {
  baseURL = 'http://ds.ysxrj.cn/admin.php' // 测试
} else {
  baseURL = 'https://www.hnmangguo.com/admin.php' // 正式
}

export default baseURL
